const Location = ({ loc }) => {
  return <span>{loc}, </span>;
};

export default Location;
